import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './Tasks.css';

export default function TeamsManager() {
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [expandedTeam, setExpandedTeam] = useState(null);
  const [form, setForm] = useState({ name: '', description: '', lead: '' });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [tRes, uRes] = await Promise.all([api.getTeams(), api.getUsers()]);
      setTeams(tRes.data.results || tRes.data);
      const usersData = uRes.data.results || uRes.data;
      setUsers(usersData.map((u) => ({
        id: u.id,
        username: u.username,
        full_name: [u.last_name, u.first_name].filter(Boolean).join(' '),
        position: u.position,
      })));
    } catch { /* ignore */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const handleCreate = async () => {
    if (!form.name || !form.lead) return;
    setSaving(true);
    try {
      await api.createTeam(form);
      setShowForm(false);
      setForm({ name: '', description: '', lead: '' });
      load();
    } catch (e) {
      alert('Не удалось создать: ' + (e.response?.data?.detail || e.message));
    }
    setSaving(false);
  };

  const handleAddMember = async (teamId, userId) => {
    if (!userId) return;
    try {
      await api.addTeamMember(teamId, { user: userId, role: 'member' });
      load();
    } catch (e) {
      alert('Не удалось добавить: ' + (e.response?.data?.detail || e.message));
    }
  };

  const handleRemoveMember = async (teamId, userId) => {
    if (!window.confirm('Удалить участника из команды?')) return;
    try {
      await api.removeTeamMember(teamId, userId);
      load();
    } catch (e) {
      alert('Не удалось удалить: ' + (e.response?.data?.detail || e.message));
    }
  };

  const handleDeleteTeam = async (teamId) => {
    if (!window.confirm('Удалить команду?')) return;
    try {
      await api.deleteTeam(teamId);
      load();
    } catch (e) {
      alert('Не удалось удалить: ' + (e.response?.data?.detail || e.message));
    }
  };

  return (
    <div className="tasks-page">
      <div style={{ marginBottom: 8 }}>
        <Link to="/tasks" style={{ color: '#6b7280', textDecoration: 'none', fontSize: 14 }}>← Дашборд задач</Link>
      </div>
      <h1>Команды</h1>

      <div className="tasks-toolbar">
        <button className="tasks-btn primary" onClick={() => setShowForm(true)}>+ Новая команда</button>
      </div>

      {loading ? (
        <div className="tasks-empty">Загрузка…</div>
      ) : teams.length === 0 ? (
        <div className="tasks-empty">Команд пока нет</div>
      ) : (
        <div className="tasks-grid">
          {teams.map((t) => {
            const expanded = expandedTeam === t.id;
            const memberIds = (t.members || []).map((m) => m.user);
            const availableUsers = users.filter((u) => !memberIds.includes(u.id) && u.id !== t.lead);
            return (
              <div className="tasks-card" key={t.id} style={{ cursor: 'default' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <h3>{t.name}</h3>
                  <button className="tasks-btn danger" onClick={() => handleDeleteTeam(t.id)}>Удалить</button>
                </div>
                <div className="meta">
                  Лид: <strong>{t.lead_detail?.full_name || t.lead_detail?.username}</strong>
                </div>
                <div className="meta">Участников: {t.members_count}</div>
                {t.description && <div className="meta" style={{ marginTop: 6 }}>{t.description}</div>}
                <button
                  className="tasks-btn"
                  style={{ marginTop: 10, width: '100%' }}
                  onClick={() => setExpandedTeam(expanded ? null : t.id)}
                >
                  {expanded ? 'Свернуть' : 'Участники'}
                </button>
                {expanded && (
                  <div style={{ marginTop: 10 }}>
                    {(t.members || []).map((m) => (
                      <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', fontSize: 13 }}>
                        <span>{m.user_detail?.full_name || m.user_detail?.username}</span>
                        <button className="tasks-btn danger" style={{ padding: '2px 8px' }} onClick={() => handleRemoveMember(t.id, m.user)}>✕</button>
                      </div>
                    ))}
                    <div style={{ marginTop: 8 }}>
                      <select
                        className="tasks-select"
                        onChange={(e) => { if (e.target.value) { handleAddMember(t.id, e.target.value); e.target.value = ''; } }}
                        defaultValue=""
                      >
                        <option value="">+ Добавить участника…</option>
                        {availableUsers.map((u) => (
                          <option key={u.id} value={u.id}>{u.full_name || u.username}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div className="tasks-modal-overlay" onClick={() => setShowForm(false)}>
          <div className="tasks-modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowForm(false)}>×</button>
            <h2>Новая команда</h2>
            <div className="tasks-form-row">
              <label>Название*</label>
              <input className="tasks-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="tasks-form-row">
              <label>Описание</label>
              <textarea className="tasks-textarea" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
            </div>
            <div className="tasks-form-row">
              <label>Лид*</label>
              <select className="tasks-select" value={form.lead} onChange={(e) => setForm({ ...form, lead: e.target.value })}>
                <option value="">— выбрать —</option>
                {users.map((u) => <option key={u.id} value={u.id}>{u.full_name || u.username}</option>)}
              </select>
            </div>
            <div className="tasks-form-actions">
              <button className="tasks-btn" onClick={() => setShowForm(false)}>Отмена</button>
              <button className="tasks-btn primary" onClick={handleCreate} disabled={saving || !form.name || !form.lead}>
                {saving ? 'Создание…' : 'Создать'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
